Ext.define('SA.data.Comparison', {
    alias: 'view.comparison',
    extend: 'SA.data.ReportView',

    mixins: {
        filterable: 'SA.data.mixin.Filterable',
        locations: 'SA.data.mixin.ManyLocations'
    },

    statics: {
        create({project, country, censusRelease, name, locationItems, attributes}) {
            var data = {
                type: 'table',
                attributes: attributes.filter(id => this.supportsAttribute(id)),
                buildingBlocksCensusRelease: censusRelease,
                filterVisibility: 'strikeout',
                locationItems: this.ensureCountryIsRightmostColumn(country, locationItems),
                name
            };

            return new SA.data.Comparison({project, data});
        },

        ensureCountryIsRightmostColumn(country, locations) {
            var country = SA.data.LocationsCache.toLocationItem(country.getLocationSeries()),
                locationsExcludingCountry = locations.filter(location => !SA.data.LocationsCache.sameLocation(location, country));

            return [...locationsExcludingCountry, country];
        },

        supportsAttribute(attribute) {
            return SA.data.AttributesCache.isPolygonAttribute(attribute);
        }
    },

    addLocationImpl(location) {
        this.mixins.locations.addLocationImpl.call(this, location);

        this.project.addLocation(location);
    },

    createController() {
        return new SA.ComparisonController(this);
    },

    createDataMap() {
        return new SA.data.DataMap({
            country: this.getCountry()
        });
    },

    getExportQuery() {
        var attributes = this.getAttributes(),
            locations = this.getQueryLocations(),
            filter = this.getFilterQuery(),
            filterVisibility = this.getFilterVisibility(),
            query = this.getDataMap().createQueryConfig(attributes, locations),
            baseColumns = ['name', 'geographicUnitName'],
            pluck = Ext.Array.pluck;

        query.sort = [['desc', 'locationSeries'].concat(pluck(locations, 'id'))];

        if (filter && filterVisibility === 'hide') {
            query.filter = filter;
        }

        query.fields = SA.Exports.getColumnExpressions({attributes, baseColumns, filter, filterVisibility});

        return query;
    },

    getReportData(cfg) {
        cfg = cfg || {};

        var map = this.getDataMap(),
            filter = this.getFilterQuery(),
            derived;

        if (filter && this.getFilterVisibility() !== 'disable') {
            derived = this.getStrikeoutFilterDerivedAttribute(filter);
        }

        map.ensure({
            attributes: this.getAttributes(),
            derivedAttributes: derived,
            locations: this.getQueryLocations(),

            fn: cfg.fn,
            scope: cfg.scope
        });

        return map.getData();
    },

    getType() {
        return 'comparison';
    },

    hasCountry() {
        var locationSeries = SA.Institution.getCountry(this.getCountry()).getLocationSeries();

        return this.containsLocation(locationSeries);
    },

    isTransposed() {
        return !!this.transposed;
    },

    onCustomLocationUpdateImpl(location) {
        this.getDataMap().removeLocation(SA.data.LocationsCache.normalizeLocation(location));
    },

    removeAttributeImpl(attribute) {
        this.callParent([attribute]);

        this.auditFilter();
    },

    setFilterImpl(filter) {
        var changed = this.mixins.filterable.setFilterImpl.call(this, filter);

        if (changed) {
            this.getDataMap().removeAttribute('filter');
        }

        return changed;
    },

    setTransposed(transposed) {
        this.transposed = transposed;
    },

    toggleTransposed() {
        this.setTransposed(!this.isTransposed());
    }
});